import { useStyles } from "../style";
import { TextField } from "@mui/material";
import { getTranslateByKey } from "@/main/services/utils";
import { TextFieldVehicleProps } from "../interfaces";

export const TextFieldVehicleComponent = ({
	params,
	propsCustom: { labelDefault, setInputText, hasBorderStyle },
}: TextFieldVehicleProps) => {
	// Styles
	const classes = useStyles();

	return (
		<TextField
			{...params}
			onChange={(e) => {
				setInputText(e.target.value);
			}}
			label={labelDefault}
			placeholder={`${getTranslateByKey("information.typeSearchForVehicle")}...`}
			variant="filled"
			className={classes.inputText}
			style={hasBorderStyle ? { border: "2px solid #dedede" } : {}}
			id="id-vehicle-txt-field"
		/>
	);
};
